
import { Options, Vue } from "vue-class-component";
import RightPanel from "../../../components/rightPanel/RightPanel.vue";
import LeftPanel from "../../../components/leftPanel/LeftPanel.vue";
@Options({
  components: {
    RightPanel,
    LeftPanel
  }
})
export default class Content extends Vue {}
